import { createApi } from '@reduxjs/toolkit/query/react';
import { Endpoints } from 'src/config';
import { apiHelper } from 'src/utils/apiHelper';
import { baseQuery, tagType } from 'src/utils/baseQuery';

const tags = {
  list: 'package-list',
};

const PackageApi = createApi({
  reducerPath: 'package-api',
  baseQuery: baseQuery(),
  tagTypes: [tags.list],
  endpoints: (builder) => ({
    getPackages: builder.query({
      providesTags: [tagType(tags.list)],
      query: (body) => apiHelper(Endpoints.package.list, body),
    }),
    createPackage: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.package.create,
        method: 'post',
        body: body,
      }),
    }),
    editPackage: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.package.edit,
        method: 'post',
        body: body,
      }),
    }),
    deletePackage: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.package.delete,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const { useGetPackagesQuery, useCreatePackageMutation, useEditPackageMutation, useDeletePackageMutation } =
  PackageApi;
export { PackageApi };
